import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { DataforsyningenToken } from '../dataforsyningen/Dataforsyningen'
import { ContextTag } from '../wiki/Wiki'
import { GeoLayer, AbstractLayer, AbstractLayerOptions, SwitchSubLayers } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the WindmillsAtSea WMS source from Dataforsyningen.
 */
class WindmillsAtSeaLayer extends AbstractLayer implements GeoLayer {
  private static readonly token: string = DataforsyningenToken
  static readonly defaultParams: LayerParamsObject = {
    opacity: 1,
    switchSubLayers: {
      labelId: 'layerpicker.switchsublayer',
      sublayers: [
        {
          labelId: 'map.layer.soiltypes.sublayer.havvindmoelle',
          subLayer: 'havvindmoelle',
          enabled: true
        },
        {
          labelId: 'map.layer.soiltypes.sublayer.havvindmoellepark',
          subLayer: 'havvindmoellepark',
          enabled: true
        },
        {
          labelId: 'map.layer.soiltypes.sublayer.udbudsomraade',
          subLayer: 'udbudsomraade',
          enabled: true
        },
        {
          labelId: 'map.layer.soiltypes.sublayer.aabendoeransoegningsomraade',
          subLayer: 'aaben_doer_ansoegningsomraade',
          enabled: true
        },
        {
          labelId: 'map.layer.soiltypes.sublayer.aabendoerprocedure',
          subLayer: 'aaben_doer_procedure',
          enabled: true
        }
      ]
    }
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.WINDMILLS_AT_SEA,
      enabled: true,
      minZoom: 0,
      zIndex: 4
    }
    super({ ...defaultOptions, ...options })

    let { switchSubLayers, opacity } = options.params
    opacity = opacity === undefined ? WindmillsAtSeaLayer.defaultParams.opacity : opacity
    const subLayers = (switchSubLayers as SwitchSubLayers)?.sublayers
      .filter(subLayer => subLayer.enabled)
      .map(subLayer => subLayer.subLayer)
      .reverse()

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://api.dataforsyningen.dk/havvind',
        params: {
          layers: subLayers,
          token: WindmillsAtSeaLayer.token,
          transparent: 'TRUE'
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.WINDMILLS_AT_SEA,
      name: 'map.layer.windmillsatsea',
      group: LayerGroup.WINDPOWER,
      contextTags: [
        ContextTag.WINDMILLS_AT_SEA
      ],
      themes: [DataTheme.ENERGY],
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geodatastyrelsen
    }
  }
}

export default WindmillsAtSeaLayer
